import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaChatReadCursorCreatedPayload = z.object({
    chatId: schemaId,
    lastSeenMessageId: schemaId,
    userId: schemaId,
});

export type Schema_ChatReadCursorCreatedPayload = z.infer<typeof schemaChatReadCursorCreatedPayload>;
